import filterByKeywords from './filters/filterByKeywords';
import filterByProvince from './filters/filterByProvince';
import filterByScope from './filters/filterByScope';
import filterByDate from './filters/filterByDate';

/**
 * Filters event list with given filter values.
 * @export
 * @param {object} filterObject
 * @param {Array.<Event>} events
 * @returns {Array.<Event>}
 */
export default function filterEvents(filterObject, events) {
  return events.filter(event => filterEvent(event, filterObject));
}

/**
 * Get filtered list of events based on app state.
 * @export
 * @param {object} state Redux state of the app.
 * @returns {Array.<Event>}
 */
export function getFilteredEvents(state) {
  return filterEvents(state.filter, state.events.allEvents);
}

function filterEvent(event, filterObject) {
  return filterByDate(event, filterObject.STARTDATE, filterObject.ENDDATE)
          && filterByProvince(event, filterObject.MAAKUNTA)
          && filterByScope(event, filterObject.LAAJUUS)
          && filterByKeywords(event, filterObject.TAGSEARCH);
}



// WEBPACK FOOTER //
// ./src/services/HandleFiltering.js